import HeadTittle from '../../../components/HeadTittle';
import { IconBackLoginOptions } from '../../../components/buttons/IconButtons';
import routes from '../../../Routes/routes';
import { Box } from '@mui/material';
import DeliveredServicesMainApp from './Functionality/DeliveredServicesMainApp';
import StepTab from '../../../components/StepperTabs/StepTab';
import StepperTabs from '../../../components/StepperTabs/StepperTabs';
import DivContainerBody from '../../../components/DivContainerBody';
import { TAB_PERMISSION_DELIVERED_SERVICES, TABS_DELIVERED_SERVICES } from './Model/Model';
import Services from './SubComponents/Services';
import History from './SubComponents/History';
import ExportDataBtn from '../../../components/buttons/ExportDataBtn';
import ConnectionStatus from './SubComponents/ConnectionStatus';
import React from "react";

/**
 * @Author      Susana García Rodríguez
 * @JobTitle    Frontend Developer
 * @Email       sgarcia@ibl.mx
 */

const DeliveredServicesMain = () => {
    const {
        steps,
        activeStep,
        setActiveStep,
        handleStepChange,
        isOnline,
        item,
        setItem,
        handleChange,
        search,
        setIsOnline,
        modified,
        setModified,
        moduleId,
        bodyForExport,
        setBodyForExport,
        option,
        permissionButtons,
        emptyFields,
        setEmptyFields
    } = DeliveredServicesMainApp();

    return (
        <>
            <HeadTittle name={'delivered_services'} IconBack={IconBackLoginOptions} link={routes.login}>
                <Box className='d-flex gap-2 justify-content-end align-items-center mb-2'>
                    <ConnectionStatus
                        isOnline={isOnline}
                        setModified={setModified}
                        showStatus={activeStep === TABS_DELIVERED_SERVICES.SERVICES.INDEX}
                    />
                    {permissionButtons(TAB_PERMISSION_DELIVERED_SERVICES().EXPORT) &&
                    ((activeStep === TABS_DELIVERED_SERVICES.SERVICES.INDEX) ||
                        (activeStep === TABS_DELIVERED_SERVICES.HISTORY.INDEX && item?.date)) &&
                        <ExportDataBtn
                            id='btn_dsm_export'
                            moduleId={moduleId}
                            searchElement={item.search}
                            search={search}
                            option={option}
                            body={bodyForExport}
                        />
                    }
                </Box>
            </HeadTittle>
            <DivContainerBody>
                <StepperTabs
                    onlyTab={true}
                    disabled={false}
                    steps={steps}
                    activeStep={activeStep}
                    isStepOptional={() => {}}
                    setActiveStep={setActiveStep}
                    handleStepChange={handleStepChange}
                >
                    <StepTab index={TABS_DELIVERED_SERVICES.SERVICES.INDEX} activeStep={activeStep}>
                        {activeStep === TABS_DELIVERED_SERVICES.SERVICES.INDEX && item && (
                            <Services
                                item={item}
                                setItem={setItem}
                                handleChange={handleChange}
                                option={option}
                                isOnline={isOnline}
                                setIsOnline={setIsOnline}
                                setBodyForExport={setBodyForExport}
                                modified={modified}
                                setModified={setModified}
                            />
                        )}
                    </StepTab>
                    <StepTab index={TABS_DELIVERED_SERVICES.HISTORY.INDEX} activeStep={activeStep}>
                        {activeStep === TABS_DELIVERED_SERVICES.HISTORY.INDEX && item && (
                            <History
                                item={item}
                                setItem={setItem}
                                handleChange={handleChange}
                                option={option}
                                setBodyForExport={ setBodyForExport}
                                modified={modified}
                                setModified={setModified}
                                emptyFields={emptyFields}
                                setEmptyFields={setEmptyFields}
                            />
                        )}
                    </StepTab>
                </StepperTabs>
            </DivContainerBody>
        </>
    );
};

export default DeliveredServicesMain;
